<template>
  <div class="main-slide">
    <main-slide-image-slot
      :img_src="img_src"
      :lazy_img_src="lazy_img_src"
      class="main-slide__block">
      <div v-if="add_shadow"
           class="main-slide__shadow"/>
      <div class="main-slide__fill main-slide__fill-semicircle">
        <semicircle-icon/>
      </div>
    </main-slide-image-slot>
    <div class="container main-slide__container">
      <div class="position-relative">
        <div class="main-slide__title-block">
          <change-text-block
            class="main-slide__title"
            :text="get_title"
            :texts_to_change="other_titles"
            :tag="title_tag"
          />
        </div>
        <div class="main-slide__fill-xs main-slide__fill-semicircle">
          <semicircle-icon/>
        </div>
      </div>
      <component
        :is="sub_title_tag"
        class="main-slide__sub-title">
        {{ sub_title }}
      </component>
      <div
        v-if="btn_text && btn_text"
        class="main-slide__btn">
        <default-button
          :is_light="btn_link_is_white"
          :href="btn_link">
          {{btn_text}}
        </default-button>
      </div>
    </div>
  </div>
</template>

<script>
import MainSlideImageSlot from "../slots/MainSlideImageSlot.vue";
import DefaultButton from "../slots/DefaultButton.vue";
import SemicircleIcon from "../fill_svg/SemicircleIcon.vue";
import WaveIcon from "../fill_svg/WaveIcon.vue";
import WaveSmallerIcon from "../fill_svg/WaveSmallerIcon.vue";
import ChangeTextBlock from "../small_parts/ChangeTextBlock.vue";

export default {
  name: "MainSlide",
  components: {
    ChangeTextBlock,
    DefaultButton,
    MainSlideImageSlot,
    SemicircleIcon,
    WaveIcon,
    WaveSmallerIcon,
  },
  props: {
    /**props**/
    img_src: {
      type: String,
      default: '/images/uploads-main-slide.jpeg',
      admin_type: 'image',
    },
    lazy_img_src: {
      type: String,
      default: '',
      admin_type: 'image',
    },
    titles: {
      type: Array,
      default: () => [],
      admin_type: 'array',
      array_values: {
        title: {
          type: String,
          required: true,
          admin_type: 'input',
        },
      }
    },

    title_tag: {
      type: String,
      default: 'h1',
      admin_type: 'select',
      admin_data_values: [
        'h1', 'h2', 'h3', 'h4', 'h5', 'h6'
      ],
    },
    sub_title: {
      type: String,
      default: '',
      admin_type: 'input',
    },
    sub_title_tag: {
      type: String,
      default: 'h3',
      admin_type: 'select',
      admin_data_values: [
        'h1', 'h2', 'h3', 'h4', 'h5', 'h6'
      ],
    },
    btn_text: {
      type: String,
      default: '',
      admin_type: 'input',
    },
    btn_link: {
      type: String,
      default: '',
      admin_type: 'input',
    },
    btn_link_is_white: {
      type: Boolean,
      default: false,
      admin_type: 'checkbox',
    },
    add_shadow: {
      type: Boolean,
      default: false,
      admin_type: 'checkbox',
    },
    /**props**/
  },
  computed: {
    get_title() {
      let title_item = this.titles.shift()
      return title_item?.title || ''
    },
    other_titles() {
      return this.titles.map(el => el.title)
    }
  }
}
</script>
